import { render } from "./BasesSection.vue?vue&type=template&id=0d2c3556&scoped=true"
import script from "./BasesSection.vue?vue&type=script&lang=js"
export * from "./BasesSection.vue?vue&type=script&lang=js"

import "./BasesSection.vue?vue&type=style&index=0&id=0d2c3556&lang=scss&scoped=true"

import exportComponent from "/var/www/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0d2c3556"]])

export default __exports__